import {ReactElement, useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box, Container, Divider, Grid, IconButton} from '@mui/material';
import Header from './components/Header';
import Menu from './components/Menu';
import TopBar from './components/TopBar';
import logo from './images/logo.svg';
import './styles.css';

export default function PemsaHeader(): ReactElement {
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  function handleMenuIconButtonClick() {
    setIsMenuOpened((i) => !i);
  }

  return (
    <>
      <TopBar />
      <Box sx={{bgcolor: '#0B0B0B', py: 2}}>
        <Container>
          <Grid container component="header">
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: {xs: 'space-between', md: 'center'},
                  flexDirection: {xs: 'row', md: 'column'},
                  height: '100%'
                }}
              >
                <img src={logo} className="logo" alt="Pemsa" fetch-priority="high" />
                <IconButton
                  onClick={handleMenuIconButtonClick}
                  sx={{
                    display: {
                      xs: 'inline-block',
                      md: 'none'
                    },
                    color: 'common.white'
                  }}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={9}>
              <Menu isMenuOpened={isMenuOpened} />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Divider />

      <Container sx={{mb: 4}}>
        <Header />
      </Container>
    </>
  );
}
